var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16669 3.5L5.19928 5.7849C6.68595 6.62725 7.31409 6.62725 8.80077 5.7849L12.8334 3.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17589 7.86077C1.21402 9.64904 1.23309 10.5431 1.89291 11.2055C2.55273 11.8678 3.47105 11.8908 5.30767 11.937C6.43961 11.9655 7.56043 11.9655 8.69239 11.937C10.529 11.8908 11.4473 11.8678 12.1072 11.2055C12.767 10.5431 12.786 9.64904 12.8241 7.86077C12.8364 7.28578 12.8364 6.71423 12.8241 6.13924C12.786 4.35101 12.767 3.45689 12.1072 2.79456C11.4473 2.13222 10.529 2.10915 8.69239 2.063C7.56043 2.03456 6.43961 2.03456 5.30767 2.063C3.47105 2.10914 2.55273 2.13221 1.89291 2.79455C1.23308 3.45689 1.21402 4.351 1.17588 6.13924C1.16362 6.71423 1.16362 7.28578 1.17589 7.86077Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.6191f9d32d4c09436154b5e0648cd45b.svg";
export { ForwardRef as ReactComponent };